import AssetsPage from "components/dashboard/assets-page";
import { FunctionComponent } from "react";

interface ModelsPageProps {}

const ModelsPage: FunctionComponent<ModelsPageProps> = () => {
  return <AssetsPage assetType="model" />;
};

export default ModelsPage;
